import type { JSX } from 'react';

import { NavLink } from '@components/NavLink/NavLink';

import './SiteLogo.less';

export const SiteLogo = (): JSX.Element => {
  return (
    <div className="site-logo">
      <NavLink to="/" className="site-logo-text">
        BETWEEN WORLDS
      </NavLink>
      <div className="site-logo-alpha">ALPHA</div>
    </div>
  );
};
